import { GetIntegrationAgencySettingsResponseTO } from 'models/InternalIntegrationSetting';
import PaginatedPropertiesScroll from 'pages/integrations/integrationDetails/components/propertiesList/propertiesResults/PaginatedPropertiesScroll';
import PropertyListItem from './propertyListItem/PropertyListItem';

const PropertiesResults = ({
  integrationAgencySettings,
}: {
  integrationAgencySettings: GetIntegrationAgencySettingsResponseTO;
}) => {
  return (
    <PaginatedPropertiesScroll
      integrationAgencySettings={integrationAgencySettings}
      emptyMessage="pageChannels.channelDetails.noPropertiesFound"
      PropertyListItem={PropertyListItem}
    />
  );
};

export default PropertiesResults;
